export function convertToPercentage(decimal: number): number {
  return Math.round(decimal * 10000) / 100;
}

export function convertToDecimal(percentage: number): number {
  return Math.round(percentage * 100) / 10000;
}

export function transformProbabilitiesForDisplay(apiProbabilities: unknown) {
  const discountProbs = apiProbabilities;
  const probArray = Array.isArray(discountProbs) 
    ? discountProbs 
    : ((discountProbs as Record<string, unknown>)?.intervals || []);
  
  return (probArray as Record<string, unknown>[]).map((prob: Record<string, unknown>) => ({
    prob: convertToPercentage(prob?.prob as number || 0),
    prizes: prob?.prizes as number[] || []
  }));
}

export function transformProbabilitiesForAPI(frontendProbabilities: { prob: number; prizes: number[] }[]) {
  return frontendProbabilities.map(prob => ({
    ...prob,
    prob: convertToDecimal(prob.prob)
  }));
}
